import type { BankanQuoteColumn, MarketingPlanBankanColumn } from "@qw/graphql";
import { Column, type ColumnStates } from "@qw/ui";
import { useParams } from "react-router";
import { opportunityColumns, quoteColumns } from "../constants/bankan-columns";
import { BankanOpportunities } from "./bankan-opportunities";
import { BankanQuotes } from "./bankan-quotes";

export const BankanColumn = () => {
  const { column } = useParams<{ column: ColumnStates }>();

  if (!column) {
    return null;
  }

  let content = null;

  if (opportunityColumns.includes(column as MarketingPlanBankanColumn)) {
    content = <BankanOpportunities column={column as MarketingPlanBankanColumn} />;
  }

  if (quoteColumns.includes(column as BankanQuoteColumn)) {
    content = <BankanQuotes column={column as BankanQuoteColumn} />;
  }

  return <Column className="bg-background divide-y">{content}</Column>;
};
